import { Box } from '@factorialco/deprecated-design-system'

import { MotionInformation } from 'modules/finance/components/MotionInformation'

import { Card } from '../components/Card'
import { SectionData } from '../types'
import * as styles from './index.vanilla.css'

interface Props {
  information: {
    motion: {
      url: string
      alt: string
      type: 'image' | 'video'
    }
    body: {
      title: string
      subTitle?: string
      description?: string
      children?: React.ReactNode
    }
  }
  sections: SectionData[]
}

export const Base = ({ information, sections }: Props) => {
  return (
    <Box className={styles.container}>
      <Box
        paddingTop="s48"
        style={{
          maxWidth: '1300px',
        }}
      >
        <MotionInformation
          motion={{
            url: information.motion.url,
            alt: information.body.title,
            type: information.motion.type,
          }}
          body={{
            title: information.body.title,
            ...(information.body.subTitle && {
              subTitle: information.body.subTitle,
            }),
            ...(information.body.description && {
              description: information.body.description,
            }),
            ...(information.body.children && {
              children: (
                <Box
                  gap="s12"
                  flexDirection="row"
                  paddingTop="s8"
                  className={styles.buttonsContainer}
                >
                  {information.body.children}
                </Box>
              ),
            }),
          }}
        />
        <Box gap="s40" flexDirection="row" paddingTop="s48" className={styles.cardContainer}>
          {sections.map((section) => (
            <Card
              key={section.title}
              title={section.title}
              description={section.description}
              img={section.img}
            />
          ))}
        </Box>
      </Box>
    </Box>
  )
}
